export default "__VITE_ASSET__0a690525__"